import { State } from '../../reducer';
import { namespace } from '.';
import { createSelector } from 'reselect';

const getDraftSelectorState = (state: State) => state[namespace].draft;
export const getDraftSelector = createSelector([getDraftSelectorState], (s) => s);
const getIsLoadingSelectorState = (state: State) => state[namespace].isLoading;
export const getIsLoadingSelector = createSelector([getIsLoadingSelectorState], (s) => s);
const getIsNotFoundSelectorState = (state: State) => state[namespace].isNotFound;
export const getIsNotFoundSelector = createSelector([getIsNotFoundSelectorState], (s) => s);
